import { orgId } from "@common/schema/organization/fields";

export {
  orgId
}

export const domainId = {
  label: "Domain Id",
  type: "string",
};

export const domain = {
  label: "Domain",
  type: "string",
  minLength: 3
};


export const description = {
  label: "Description",
  type: "string",
  minLength: 8
};

export const status = {
  type: "string",
};


export const privateKey = {
  label: "Private Key",
  type: "string",
  textarea: true
};


export const publicKey = {
  label: "Public Key",
  type: "string",
  textarea: true
};


export const webhookRoute = {
  label: "Webhook Route",
  type: "string"
};


export const webhookSecret = {
  label: "Webhook Secret",
  type: "string"
};





